import { number } from 'prop-types';
import modelFieldMessages from './modelFieldMessages';

class Recipe {
  static fields = {
    id: {
      key: 'id',
      type: 'string',
      title: modelFieldMessages.id,
      editable: false
    },
    identifier: {
      key: 'identifier',
      type: 'string',
      title: modelFieldMessages.identifier
    },
    numOfLayers: {
      key: 'numOfLayers',
      type: 'string',
      title: modelFieldMessages.numOfLayers
    },
    oversizeWidth: {
      key: 'oversizeWidth',
      type: 'string',
      title: modelFieldMessages.oversizeWidth,
      validation: ['float']
    },
    oversizeWidthMoelven: {
      key: 'oversizeWidth',
      type: 'string',
      title: modelFieldMessages.coveringWidth,
      validation: ['float']
    },
    oversizeThickness: {
      key: 'oversizeThickness',
      type: 'string',
      title: modelFieldMessages.oversizeThickness
    },
    oversize: {
      key: 'oversize',
      type: 'string',
      title: modelFieldMessages.oversizeLength
    },
    // sandingTop: {
    //   key: 'sandingTop',
    //   format: {
    //     type: 'boolean'
    //   },
    //   title: modelFieldMessages.sandingTop
    // },
    sandingTop: {
      key: 'sandingTop',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.sandingTop
    },
    sandingBottom: {
      key: 'sandingBottom',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.sandingBottom
    },
    useCGV: {
      key: 'useCGV',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.useCGV
    },
    noLayers: {
      key: 'layers',
      type: 'arraylength',
      title: modelFieldMessages.layers
    },
    panelThickness: {
      key: 'panelThickness',
      type: 'string',
      title: modelFieldMessages.panelThickness,
      blank: false,
      validation: ['float', 'aboveZero']
    },
    panelWidth: {
      key: 'panelWidth',
      type: 'string',
      title: modelFieldMessages.panelWidth,
      blank: false,
      validation: ['float', 'aboveZero']
    },
    panelLength: {
      key: 'panelLength',
      type: 'string',
      title: modelFieldMessages.panelLength,
      blank: false,
      validation: ['float', 'aboveZero']
    },
    orderPicture: {
      key: 'picture',
      type: 'drawPicture',
      title: modelFieldMessages.picture,
      function: 'getCLTRecipeImage'
    },
    getOrderWithRecipeImage: {
      key: 'picture',
      type: 'drawPicture',
      title: modelFieldMessages.picture,
      function: 'getOrderWithRecipeImage'
    },
    articleNumber: {
      key: 'articleNumber',
      type: 'string',
      title: modelFieldMessages.articleNumber,
      editable: false
    },
    added_at: {
      key: 'added_at',
      title: modelFieldMessages.added_at,
      format: {
        type: 'date'
      }
    },
    stackHeight: {
      key: 'stackHeight',
      type: 'string',
      title: modelFieldMessages.stackHeight,
      editable: false
    },
    strap1: {
      key: 'strap1',
      type: 'string',
      title: modelFieldMessages.strap1,
      editable: false
    },
    strap2: {
      key: 'strap2',
      type: 'string',
      title: modelFieldMessages.strap2,
      editable: false
    },
    strap3: {
      key: 'strap3',
      type: 'string',
      title: modelFieldMessages.strap3,
      editable: false
    },
    strap4: {
      key: 'strap4',
      type: 'string',
      title: modelFieldMessages.strap4,
      editable: false
    },
    stick1: {
      key: 'stick1',
      type: 'string',
      title: modelFieldMessages.stick1,
      editable: false
    },
    stick2: {
      key: 'stick2',
      type: 'string',
      title: modelFieldMessages.stick2,
      editable: false
    },
    stick3: {
      key: 'stick3',
      type: 'string',
      title: modelFieldMessages.stick3,
      editable: false
    },
    stick4: {
      key: 'stick4',
      type: 'string',
      title: modelFieldMessages.stick4,
      editable: false
    },
    stick5: {
      key: 'stick5',
      type: 'string',
      title: modelFieldMessages.stick5,
      editable: false
    },
    bunksHeight: {
      key: 'bunksHeight',
      type: 'string',
      title: modelFieldMessages.bunksHeight,
      editable: false
    },
    stickLength: {
      key: 'stickLength',
      type: 'string',
      title: modelFieldMessages.stickLength,
      editable: false
    },
    bunksLength: {
      key: 'bunksLength',
      type: 'string',
      title: modelFieldMessages.bunksLength,
      editable: false
    },
    foilType: {
      key: 'foilType',
      type: 'string',
      title: modelFieldMessages.foilType,
      editable: false
    },
    frommStrap1: {
      key: 'frommStrap1',
      type: 'string',
      title: modelFieldMessages.frommStrap1,
      editable: false
    },
    frommStrap2: {
      key: 'frommStrap2',
      type: 'string',
      title: modelFieldMessages.frommStrap2,
      editable: false
    },
    frommStrap3: {
      key: 'frommStrap3',
      type: 'string',
      title: modelFieldMessages.frommStrap3,
      editable: false
    },
    bunk1: {
      key: 'bunk1',
      type: 'string',
      title: modelFieldMessages.bunk1,
      editable: false
    },
    bunk2: {
      key: 'bunk2',
      type: 'string',
      title: modelFieldMessages.bunk2,
      editable: false
    },
    bunk3: {
      key: 'bunk3',
      type: 'string',
      title: modelFieldMessages.bunk3,
      editable: false
    },
    bunk4: {
      key: 'bunk4',
      type: 'string',
      title: modelFieldMessages.bunk4,
      editable: false
    },
    remaCode: {
      key: 'remaCode',
      type: 'string',
      title: modelFieldMessages.remaCode,
      editable: false
    },
    plasticCover: {
      key: 'plasticCover',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.plasticCover,
      editable: false
    },
    topBunks: {
      key: 'topBunks',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.topBunks,
      editable: false
    },
    corners: {
      key: 'corners',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.corners,
      editable: false
    },
    cornersExtra: {
      key: 'cornersExtra',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.cornersExtra,
      editable: false
    },
    softHandling: {
      key: 'softHandling',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.softHandling,
      editable: false
    },
    frontEnd: {
      key: 'frontEnd',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.frontEnd,
      editable: false
    },
    number: {
      key: 'number',
      type: 'string',
      title: modelFieldMessages.number
      // editable: false
    },
    turning0: {
      key: 'turning0',
      type: 'string',
      title: modelFieldMessages.turning0
      // editable: false
    },
    turning1: {
      key: 'turning1',
      type: 'string',
      title: modelFieldMessages.turning1
      // editable: false
    },
    turning2: {
      key: 'turning2',
      type: 'string',
      title: modelFieldMessages.turning2
      // editable: false
    }
  };

  static actions = {
    deleteRecipe: {
      key: 'delete',
      type: 'delete',
      dispatch: 'deleteRecipe',
      modal: {
        modal: true,
        buttonText: 'deleteRecipe',
        key: 'deleteRecipe',
        action: 'deleteRecipe',
        actionData: {
          target: 'backend',
          source: 'orders/recipes/',
          url: '/api/v1/orders/recipes/remove_recipe/',
          items: 'selected',
          callType: 'POST'
        }
      }
    },
    editRecipe: {
      key: 'edit',
      type: 'edit',
      identifier: 'editRecipe',
      configuration: {
        model: 'recipe',
        url: '/api/v1/orders/recipes/'
      }
    }
  };
}

export default Recipe;
